import { Lead } from './types';

export const INITIAL_LEADS: Lead[] = [
  // --- WEBSITE LEADS ---
  {
    id: 'w-1',
    name: 'TEST DONT DELETE',
    company: 'Armellini Test Facility',
    email: 'snesbitt@armellini.com',
    dealValue: 15000,
    pipeline: 'Website Leads',
    status: 'Website Lead',
    lastContacted: '2026-07-14',
    owner: 'Mark Sterling, Sarah Nesbitt',
    contactPerson: 'TEST',
    location: '3446 SW Armellini Ave',
    quoteDetails: '2.9/cube + $1.58/handling + FSC',
    nextSteps: 'DO NOT DELETE',
    phone: '7723337075',
    service: 'LTL Care Of',
    industry: 'Food & Beverage',
    appLink: 'https://armellini-credit-application-182772255814.us-west1.run.app/?itemId=18180690840',
    followUpDate: '2026-07-19',
  },
  {
    id: 'w-2',
    name: 'other test',
    company: 'Hilary Dev Test',
    email: 'hdedrick@armellini.com',
    dealValue: 12000,
    pipeline: 'Website Leads',
    status: 'Website Lead',
    lastContacted: '2026-07-14',
    owner: 'Hilary Dedrick, Sarah Nesbitt',
    contactPerson: 'testing for Hilary owner',
    nextSteps: 'testing for Hilary owner',
    appLink: 'https://armellini-credit-application-182772255814.us-west1.run.app/?itemId=12531058888',
  },

  // --- NEW LEADS ---
  {
    id: 'nl-1',
    name: 'Fresh Express Atlanta',
    company: 'Fresh Express Atlanta',
    email: 'bruce.taylor@freshexpress.com',
    dealValue: 75000,
    pipeline: 'New Leads',
    status: 'New Lead',
    lastContacted: '2026-01-05',
    owner: 'Fernando Perez',
    contactPerson: 'Bruce C. Taylor',
    location: 'Morrow, GA',
    nextSteps: 'Follow up with Service Details',
    phone: '16784222100',
    service: 'LTL',
    industry: 'Non-Floral',
    appLink: 'https://armellini-credit-application-182772255814.us-west1.run.app/?itemId=10915426425',
  },
  {
    id: 'nl-2',
    name: 'Veg-Land',
    company: 'Veg-Land',
    email: 'Rob@veg-land.com',
    dealValue: 48000,
    pipeline: 'New Leads',
    status: 'New Lead',
    lastContacted: 'Just now',
    owner: 'Danean Allan',
    contactPerson: 'Rob Gurney',
    location: 'Fullerton, CA',
    nextSteps: 'New contact passed along from Jerritt who is now moving to berry sales.',
    phone: '19518300209',
    service: 'LTL',
    appLink: 'https://armellini-credit-application-182772255814.us-west1.run.app/?itemId=10907329710',
    followUpDate: '2026-07-20',
  },
  {
    id: 'nl-3',
    name: 'Dianne Flowers',
    company: 'Dianne Flowers',
    email: 'Dianneflowerswh@outlook.com',
    dealValue: 35000,
    pipeline: 'New Leads',
    status: 'New Lead',
    lastContacted: '2026-01-06',
    owner: 'Danean Allan',
    contactPerson: 'Shirley Jimenez',
    location: '1722 E Bijou St',
    nextSteps: 'Phone call / web lead',
    phone: '7203277883',
    service: 'LTL Care Of',
    industry: 'Retail, Floral',
    appLink: 'https://armellini-credit-application-182772255814.us-west1.run.app/?itemId=10928194491',
  },
  {
    id: 'nl-4',
    name: 'Harris Teeter',
    company: 'Harris Teeter Supermarkets',
    email: 'phrycaj@harristeeter.com',
    dealValue: 180000,
    pipeline: 'New Leads',
    status: 'New Lead',
    lastContacted: '2026-02-16',
    owner: 'Danean Allan',
    contactPerson: 'Peter Hrycaj',
    location: 'Greensboro, NC',
    nextSteps: 'Hopefully schedule a mtg with Peter.',
    quoteDetails: 'Trailer load quoting in progress',
    phone: '7048443100',
    service: 'Trailer Load',
    industry: 'Floral',
    appLink: 'https://armellini-credit-application-182772255814.us-west1.run.app/?itemId=11285329532',
  },
  {
    id: 'nl-5',
    name: 'Betteravia / Bonipak',
    company: 'Betteravia / Bonipak',
    email: 'steve.geraci@bonipak.com',
    dealValue: 95000,
    pipeline: 'New Leads',
    status: 'New Lead',
    lastContacted: '2026-02-23',
    owner: 'Fernando Perez',
    contactPerson: 'Steve',
    location: 'Santa Maria, CA',
    nextSteps: 'Service Details sent',
    phone: '18053618787',
    service: 'LTL',
    industry: 'Non-Floral',
    appLink: 'https://armellini-credit-application-182772255814.us-west1.run.app/?itemId=11228543860',
  },
  {
    id: 'nl-6',
    name: 'Veritable Vegetable',
    company: 'Veritable Vegetable',
    email: 'karen@veritablevegetable.com',
    dealValue: 62000,
    pipeline: 'New Leads',
    status: 'New Lead',
    lastContacted: '2026-02-23',
    owner: 'Fernando Perez',
    contactPerson: 'Karen',
    location: 'San Francisco, CA',
    nextSteps: 'Follow up with Service details and DOS',
    phone: '14155504812',
    service: 'LTL',
    industry: 'Non-Floral',
    appLink: 'https://armellini-credit-application-182772255814.us-west1.run.app/?itemId=11239986226',
  },

  // --- ATTEMPTED TO CONTACT ---
  {
    id: 'ac-1',
    name: 'Las Vegas Flower Wholesale',
    company: 'Las Vegas Flower Wholesale',
    email: 'debra@lvfloral.com',
    dealValue: 55000,
    pipeline: 'Attempted to Contact',
    status: 'Attempted to Contact',
    lastContacted: '2026-03-10',
    owner: 'Fernando Perez',
    contactPerson: 'Debbie',
    nextSteps: 'Follow-up after the holiday. Current carrier Florida Beauty, 120 boxes volume, FL DOS Thursday.',
    phone: '17023830603',
    service: 'LTL',
    industry: 'Floral',
    appLink: 'https://armellini-credit-application-182772255814.us-west1.run.app/?itemId=11065860998',
  },
  {
    id: 'ac-2',
    name: 'Carlo Masi Sons & Daughter Produce',
    company: 'Carlo Masi Sons & Daughter Produce',
    email: 'RSunderlin@cmasiproduce.com',
    dealValue: 110000,
    pipeline: 'Attempted to Contact',
    status: 'Attempted to Contact',
    lastContacted: '2026-07-13',
    owner: 'Danean Allan',
    contactPerson: 'Ryan Sunderlin',
    location: '9 Wurz Avenue, Utica, NY 13502',
    nextSteps: 'Call Ryan back soon.',
    quoteDetails: '4-6 pallets of produce to Utica 2x a week.',
    phone: '13157977303',
    service: 'LTL',
    industry: 'Non-Floral',
    appLink: 'https://armellini-credit-application-182772255814.us-west1.run.app/?itemId=11260617251',
  },

  // --- COLD CALL LEADS ---
  {
    id: 'cc-1',
    name: "Frieda's",
    company: "Frieda's Specialty Produce",
    email: 'joshh@legacyproduce.com',
    dealValue: 30000,
    pipeline: 'Cold Call Leads',
    status: 'Cold Call Lead',
    lastContacted: '2026-01-19',
    owner: 'Fernando Perez',
    contactPerson: 'Josh',
    location: 'Los Angeles, CA',
    nextSteps: 'New Lead follow-up',
    service: 'LTL',
    industry: 'Non-Floral',
    appLink: 'https://armellini-credit-application-182772255814.us-west1.run.app/?itemId=10730695405',
  },
  {
    id: 'cc-2',
    name: 'Keany Produce & Gourmet',
    company: 'Keany Produce & Gourmet',
    email: 'henry.salcedo@keanyproduce.com',
    dealValue: 40000,
    pipeline: 'Cold Call Leads',
    status: 'Cold Call Lead',
    lastContacted: '2026-01-05',
    owner: 'Fernando Perez',
    contactPerson: 'Henry',
    location: 'Jessup, MD',
    nextSteps: 'New Lead follow-up',
    phone: '13017723333',
    service: 'LTL',
    industry: 'Non-Floral',
    appLink: 'https://armellini-credit-application-182772255814.us-west1.run.app/?itemId=10730767778',
  },
  {
    id: 'cc-3',
    name: 'C&C Produce',
    company: 'C&C Produce',
    email: 'dennis@ccproduce.net',
    dealValue: 25000,
    pipeline: 'Cold Call Leads',
    status: 'Cold Call Lead',
    lastContacted: '2026-01-05',
    owner: 'Fernando Perez',
    contactPerson: 'Dennis',
    location: 'Kansas City, MO',
    nextSteps: 'New Lead follow-up',
    phone: '18162414425',
    service: 'LTL',
    industry: 'Non-Floral',
    appLink: 'https://armellini-credit-application-182772255814.us-west1.run.app/?itemId=10730744781',
  },
  {
    id: 'cc-4',
    name: 'Premier ProduceOne',
    company: 'Premier ProduceOne',
    email: 'info@premierproduceone.com',
    dealValue: 50000,
    pipeline: 'Cold Call Leads',
    status: 'Cold Call Lead',
    lastContacted: '2026-01-10',
    owner: 'Danean Allan',
    contactPerson: 'Cold Call',
    nextSteps: 'Maybe try in a week or so. They have all of their own drivers.',
    quoteDetails: 'Three locations: Cleveland, Columbus, Dayton',
    service: 'LTL',
    industry: 'Produce',
    appLink: 'https://armellini-credit-application-182772255814.us-west1.run.app/?itemId=10801962599',
  },
  {
    id: 'cc-5',
    name: 'Melissas',
    company: "Melissa's Produce",
    email: 'brendav@melissas.com',
    dealValue: 70000,
    pipeline: 'Cold Call Leads',
    status: 'Cold Call Lead',
    lastContacted: '2026-01-05',
    owner: 'Fernando Perez',
    contactPerson: 'Brenda',
    location: 'Los Angeles, CA',
    nextSteps: 'Continue to email Service Details',
    phone: '12135950428',
    service: 'LTL',
    industry: 'Non-Floral',
    appLink: 'https://armellini-credit-application-182772255814.us-west1.run.app/?itemId=10800838582',
  },

  // --- QUOTED ---
  {
    id: 'q-1',
    name: 'Much Flowers',
    company: 'Much Flowers',
    email: 'sales7@muchflowers.com',
    dealValue: 150000,
    pipeline: 'Quoted',
    status: 'Sent Quote',
    lastContacted: '2026-07-17',
    owner: 'Danean Allan',
    contactPerson: 'Valeria Jauregui',
    location: 'San Antonio TX',
    quoteDetails: '2.9/cube + FSC',
    nextSteps: 'Quote LTL 3x week to HEB San Antonio (1,000 cubes 3xweek anticipated)',
    service: 'LTL',
    industry: 'Floral, Mass Market',
    appLink: 'https://armellini-credit-application-182772255814.us-west1.run.app/?itemId=12530341292',
    followUpDate: '2026-07-25',
  },
  {
    id: 'q-2',
    name: "Kenia's Flower Boutique",
    company: "Kenia's Flower Boutique",
    email: 'keniaflowers12@gmail.com',
    dealValue: 45000,
    pipeline: 'Quoted',
    status: 'Sent Credit App',
    lastContacted: '2026-07-17',
    owner: 'Hilary Dedrick',
    contactPerson: 'Kenia Fonseca',
    location: 'Ridgewood, New Jersey',
    quoteDetails: '4.2/cube + $1.58/handling + FSC',
    nextSteps: 'Bi-Weekly Shipment. Monday, Wednesday or Saturday utilizing crossdock partner Metropetals.',
    phone: '18456671274',
    service: 'LTL Care Of',
    industry: 'Floral',
    appLink: 'https://armellini-credit-application-182772255814.us-west1.run.app/?itemId=12560177238',
  },
  {
    id: 'q-3',
    name: 'Holland Greenhouses',
    company: 'Holland Greenhouses Inc.',
    email: 'casey@hollandgreenhousesinc.com',
    dealValue: 125000,
    pipeline: 'Quoted',
    status: 'Sent Quote',
    lastContacted: '2026-07-14',
    owner: 'Hilary Dedrick',
    contactPerson: 'Casey Jansen Jr',
    location: 'Miami, FL',
    quoteDetails: '3200/TL + FSC',
    nextSteps: 'Follow-Up on Quote. Southbound NJ to Miami rate $3,200.00 + fuel surcharge.',
    phone: '16094489222',
    service: 'Trailer Load',
    industry: 'Floral',
    appLink: 'https://armellini-credit-application-182772255814.us-west1.run.app/?itemId=12543859910',
  },
  {
    id: 'q-4',
    name: 'Grocery Outlet',
    company: 'Grocery Outlet Riverdale Farms',
    email: 'eduardo@riverdalefarms.com',
    dealValue: 85000,
    pipeline: 'Quoted',
    status: 'Sent Quote',
    lastContacted: '2026-03-05',
    owner: 'Danean Allan',
    contactPerson: 'Eduardo',
    quoteDetails: '3.3 + FSC (No Handling)',
    nextSteps: 'Minimum $1,200 or 363 cubes',
    service: 'LTL',
    industry: 'Floral',
    appLink: 'https://armellini-credit-application-182772255814.us-west1.run.app/?itemId=11439073438',
  },
  {
    id: 'q-5',
    name: 'Addison James Foods',
    company: 'Addison James Foods',
    email: 'chef@addisonjamesfoods.com',
    dealValue: 140000,
    pipeline: 'Quoted',
    status: 'Sent Quote',
    lastContacted: '2026-02-20',
    owner: 'Danean Allan',
    contactPerson: 'Alain J.L. Bedard',
    location: 'Palm City',
    quoteDetails: '240/Pallet',
    nextSteps: 'Meeting Chef Alain and Paola. Quote frozen TL to Valley, AL.',
    phone: '15616008886',
    service: 'Trailer Load',
    industry: 'Non-Floral',
    appLink: 'https://armellini-credit-application-182772255814.us-west1.run.app/?itemId=10054321591',
  },

  // --- IN PROCESS ---
  {
    id: 'ip-1',
    name: 'Fresca Farms',
    company: 'Fresca Farms',
    email: 'elvira@frescafarms.com',
    dealValue: 65000,
    pipeline: 'In Process',
    status: 'In Process',
    lastContacted: '2026-07-10',
    owner: 'Hilary Dedrick, Danean Allan',
    contactPerson: 'Elvira Diaz',
    location: 'Monrovia, CA',
    nextSteps: 'Follow-Up on Credit App. Offered C/O Santa Paula Hub.',
    phone: '13055918098',
    service: 'LTL, LTL Care Of',
    industry: 'Floral',
    appLink: 'https://armellini-credit-application-182772255814.us-west1.run.app/?itemId=12543839402',
  },
  {
    id: 'ip-2',
    name: 'Fresh Sends',
    company: 'Fresh Sends',
    email: 'jesse@freshsends.com',
    dealValue: 110000,
    pipeline: 'In Process',
    status: 'In Process',
    lastContacted: '2026-07-17',
    owner: 'Hilary Dedrick, Danean Allan',
    contactPerson: 'Jesse Hiss',
    location: 'Denver, CO',
    quoteDetails: '$3.15/cube + $1.58/handling + FSC',
    nextSteps: 'Follow-Up on Credit App. Weekly shipping 600 cubes.',
    phone: '19137546781',
    service: 'LTL',
    industry: 'Floral, Wholesale',
    appLink: 'https://armellini-credit-application-182772255814.us-west1.run.app/?itemId=12529446586',
  },

  // --- AWAITING FIRST SHIPMENT ---
  {
    id: 'as-1',
    name: 'JM5 Wholesale',
    company: 'JM5 Wholesale',
    email: 'jm5wholesale25@gmail.com',
    dealValue: 50000,
    pipeline: 'Awaiting First Shipment',
    status: 'Complete',
    lastContacted: '2026-07-08',
    owner: 'Hilary Dedrick, Danean Allan',
    contactPerson: 'Jason Godwin',
    location: '806 N Conecuh Street Greenville, AL 36037',
    nextSteps: 'Check Monthly Invoice Revenue for First Month in A4. Pickup @ Armellini Tucker Hub',
    phone: '13343680400',
    service: 'LTL',
    industry: 'Floral, Retail',
    appLink: 'https://armellini-credit-application-182772255814.us-west1.run.app/?itemId=12478024265',
  },

  // --- BROKERS ---
  {
    id: 'br-1',
    name: 'Arrive Logistics',
    company: 'Arrive Logistics',
    email: 'abrevick@arrivelogistics.com',
    dealValue: 80000,
    pipeline: 'Brokers',
    status: 'Broker',
    lastContacted: '2026-04-23',
    owner: 'Danean Allan',
    contactPerson: 'Alex Brevick',
    location: 'multiple',
    nextSteps: 'Broker get to know you meeting set up to look for matching possibilities.',
    phone: '15204676764',
    service: 'LTL',
    industry: 'Non-Floral',
    appLink: 'https://armellini-credit-application-182772255814.us-west1.run.app/?itemId=11436767325',
  },
  {
    id: 'br-2',
    name: 'High Tide Logistics',
    company: 'High Tide Logistics',
    email: 'tbuechele@hightidelogistics.com',
    dealValue: 45000,
    pipeline: 'Brokers',
    status: 'Broker',
    lastContacted: '2025-09-10',
    owner: 'Sarah Nesbitt',
    contactPerson: 'Tommy Buechele',
    location: 'Haines City, FL',
    nextSteps: 'See updates & subitems for more information (Garland TX to Haines City FL LTL)',
    service: 'LTL',
    industry: 'Non-Floral',
    appLink: 'https://armellini-credit-application-182772255814.us-west1.run.app/?itemId=10023896954',
  },

  // --- SHIPPER ---
  {
    id: 'sh-1',
    name: 'Green World Farm, Inc.',
    company: 'Green World Farm, Inc.',
    email: 'jhmore14@gmail.com',
    dealValue: 90000,
    pipeline: 'Shipper',
    status: 'Shipper',
    lastContacted: '2025-09-18',
    owner: 'Danean Allan',
    contactPerson: 'Jorge Moreno',
    location: '2153 NW 86th Ave, Miami, FL',
    nextSteps: 'Met in MIA; Danean to quote',
    phone: '17869420016',
    service: 'LTL',
    industry: 'Non-Floral',
    appLink: 'https://armellini-credit-application-182772255814.us-west1.run.app/?itemId=10029097254',
  },
  {
    id: 'sh-2',
    name: 'Multiflora - Vistaflor - Grower2Buyer',
    company: 'Multiflora - Vistaflor - Grower2Buyer',
    email: 'jbernal@multiflora.com',
    dealValue: 135000,
    pipeline: 'Shipper',
    status: 'Shipper',
    lastContacted: '2026-07-15',
    owner: 'Danean Allan',
    contactPerson: 'Jorge Bernal',
    nextSteps: 'Grower credit app follow-up. 2-3 pallets dry weekly going to Vista, CA',
    phone: '13055937073',
    appLink: 'https://armellini-credit-application-182772255814.us-west1.run.app/?itemId=18226415443',
  },

  // --- REVISIT LATER ---
  {
    id: 'rv-1',
    name: 'Flowers by Brian',
    company: 'Flowers by Brian',
    email: 'brian@flowersbybrian.com',
    dealValue: 55000,
    pipeline: 'Revisit Later | ADD FU DATE',
    status: 'Revisit Later | ADD FU DATE',
    lastContacted: '2025-12-18',
    owner: 'Fernando Perez',
    contactPerson: 'Brian and Brianna',
    location: 'Mineola, NY',
    nextSteps: 'Not interested now, might be interested after V-Day 2026',
    phone: '15168737900',
    service: 'LTL',
    industry: 'Floral',
    appLink: 'https://armellini-credit-application-182772255814.us-west1.run.app/?itemId=10812284126',
  },
  {
    id: 'rv-2',
    name: 'Fleurametz - NY',
    company: 'Fleurametz - NY',
    email: 'jglaser@fleurametz.com',
    dealValue: 120000,
    pipeline: 'Revisit Later | ADD FU DATE',
    status: 'Revisit Later | ADD FU DATE',
    lastContacted: '2026-03-27',
    owner: 'Danean Allan, David Armellini',
    contactPerson: 'Joe Glaser',
    location: '432 Waverly Avenue, Mamaroneck, NY',
    nextSteps: 'Email rates to Joe. Needs Mon 400 boxes, Wed/Thu 750-800 boxes.',
    service: 'LTL',
    industry: 'Floral',
    appLink: 'https://armellini-credit-application-182772255814.us-west1.run.app/?itemId=10939426133',
  },

  // --- COMPLETE ---
  {
    id: 'co-1',
    name: 'Robert Erneston Produce, Inc.',
    company: 'Robert Erneston Produce, Inc.',
    email: 'mike@ernestonproduce.com',
    dealValue: 95000,
    pipeline: 'Complete',
    status: 'Complete',
    lastContacted: '2026-05-05',
    owner: 'Fernando Perez',
    contactPerson: 'Mike',
    nextSteps: 'Follow up after shipping starts.',
    phone: '17722886345',
    service: 'LTL',
    industry: 'Non-Floral',
    appLink: 'https://armellini-credit-application-182772255814.us-west1.run.app/?itemId=11929069873',
  },
  {
    id: 'co-2',
    name: 'Copacabana Foods',
    company: 'Copacabana Foods',
    email: 'sales@copacabanafoods.com',
    dealValue: 60000,
    pipeline: 'Complete',
    status: 'Complete',
    lastContacted: '2026-05-01',
    owner: 'Sarah Nesbitt',
    contactPerson: 'Rafael',
    location: '915 W Parker Rd Suite 207, Plano, TX 75023',
    quoteDetails: '280/Pallet',
    phone: '9725550192',
    service: 'LTL',
    industry: 'Non-Floral',
    appLink: 'https://armellini-credit-application-182772255814.us-west1.run.app/?itemId=11840529739',
  }
];
